// Categorized list of SQL Server DMVs (Dynamic Management Views)
// Each category contains an array of DMV objects with name and description

export const DMV_CATEGORIES = [
  {
    category: 'Server-wide',
    dmvs: [
      { name: 'sys.dm_os_sys_memory', description: 'Memory state of SQL Server.' },
      { name: 'sys.dm_os_memory_clerks', description: 'Memory usage by each memory clerk.' },
      { name: 'sys.dm_os_memory_objects', description: 'Memory usage for memory objects.' },
      { name: 'sys.dm_os_ring_buffers', description: 'Ring buffer records for diagnostics.' },
      { name: 'sys.dm_os_performance_counters', description: 'Performance counters maintained by the server.' },
      { name: 'sys.dm_os_schedulers', description: 'SQL Server schedulers.' },
      { name: 'sys.dm_os_tasks', description: 'Tasks running on SQL Server.' },
      { name: 'sys.dm_os_threads', description: 'Threads running on SQL Server.' },
      { name: 'sys.dm_os_wait_stats', description: 'Waits encountered by threads.' },
      { name: 'sys.dm_os_loaded_modules', description: 'Loaded modules in SQL Server.' },
      { name: 'sys.dm_os_sys_info', description: 'General information about the system.' },
      { name: 'sys.dm_os_process_memory', description: 'SQL Server process memory usage.' },
      { name: 'sys.dm_os_host_info', description: 'Host operating system information.' },
    ]
  },
  {
    category: 'Database',
    dmvs: [
      { name: 'sys.dm_db_index_usage_stats', description: 'Index operation counts and last operation time.' },
      { name: 'sys.dm_db_missing_index_details', description: 'Information about missing indexes.' },
      { name: 'sys.dm_db_partition_stats', description: 'Page and row-count info for every partition.' },
      { name: 'sys.dm_db_file_space_usage', description: 'Space usage for database files.' },
      { name: 'sys.dm_db_log_space_usage', description: 'Transaction log space usage.' },
      { name: 'sys.dm_db_index_physical_stats', description: 'Physical stats of indexes.' },
      { name: 'sys.dm_db_stats_properties', description: 'Statistics object properties.' },
      { name: 'sys.dm_db_persisted_sku_features', description: 'SKU features in use.' },
      { name: 'sys.dm_db_xtp_checkpoint_files', description: 'Checkpoint file information for In-Memory OLTP.' },
    ]
  },
  {
    category: 'Query & Execution',
    dmvs: [
      { name: 'sys.dm_exec_requests', description: 'Currently executing requests.' },
      { name: 'sys.dm_exec_sessions', description: 'Authenticated sessions.' },
      { name: 'sys.dm_exec_connections', description: 'Connections established to SQL Server.' },
      { name: 'sys.dm_exec_query_stats', description: 'Aggregate performance stats for cached query plans.' },
      { name: 'sys.dm_exec_sql_text', description: 'Text of SQL batch by sql_handle.' },
      { name: 'sys.dm_exec_query_plan', description: 'Showplan XML for a batch by plan handle.' },
      { name: 'sys.dm_exec_procedure_stats', description: 'Aggregate stats for cached stored procedures.' },
      { name: 'sys.dm_exec_cached_plans', description: 'Cached query plans.' },
      { name: 'sys.dm_exec_plan_attributes', description: 'Attributes of cached plans.' },
      { name: 'sys.dm_exec_input_buffer', description: 'Input buffer for a session.' },
      { name: 'sys.dm_exec_requests', description: 'Requests currently executing.' },
    ]
  },
  {
    category: 'Transaction & Locking',
    dmvs: [
      { name: 'sys.dm_tran_locks', description: 'Currently active lock manager resources.' },
      { name: 'sys.dm_tran_active_transactions', description: 'Active transactions.' },
      { name: 'sys.dm_tran_database_transactions', description: 'Database transactions.' },
      { name: 'sys.dm_tran_session_transactions', description: 'Session transactions.' },
      { name: 'sys.dm_tran_version_store', description: 'Version store usage.' },
      { name: 'sys.dm_tran_current_transaction', description: 'Current transaction for a session.' },
    ]
  },
  {
    category: 'Replication',
    dmvs: [
      { name: 'sys.dm_repl_articles', description: 'Articles in a publication.' },
      { name: 'sys.dm_repl_schemas', description: 'Schemas in a publication.' },
      { name: 'sys.dm_repl_subscriptions', description: 'Replication subscriptions.' },
      { name: 'sys.dm_repl_traninfo', description: 'Transactional replication info.' },
    ]
  },
  {
    category: 'Full-Text Search',
    dmvs: [
      { name: 'sys.dm_fts_active_catalogs', description: 'Active full-text catalogs.' },
      { name: 'sys.dm_fts_index_population', description: 'Full-text index population status.' },
      { name: 'sys.dm_fts_memory_pools', description: 'Full-text memory pools.' },
      { name: 'sys.dm_fts_parser', description: 'Full-text parser output.' },
    ]
  },
  {
    category: 'Broker',
    dmvs: [
      { name: 'sys.dm_broker_activated_tasks', description: 'Service Broker activated tasks.' },
      { name: 'sys.dm_broker_connections', description: 'Service Broker connections.' },
      { name: 'sys.dm_broker_forwarded_messages', description: 'Forwarded Service Broker messages.' },
      { name: 'sys.dm_broker_queue_monitors', description: 'Queue monitor information.' },
    ]
  },
  {
    category: 'XEvent & Trace',
    dmvs: [
      { name: 'sys.dm_xe_sessions', description: 'Extended Events sessions.' },
      { name: 'sys.dm_xe_objects', description: 'Extended Events objects.' },
      { name: 'sys.dm_xe_packages', description: 'Extended Events packages.' },
      { name: 'sys.dm_xe_session_targets', description: 'Targets for Extended Events sessions.' },
      { name: 'sys.dm_xe_session_events', description: 'Events for Extended Events sessions.' },
      { name: 'sys.dm_xe_session_event_actions', description: 'Event actions for Extended Events sessions.' },
      { name: 'sys.dm_xe_map_values', description: 'Map values for Extended Events.' },
      { name: 'sys.dm_xe_database_sessions', description: 'Database-scoped Extended Events sessions.' },
      { name: 'sys.dm_trace_sessions', description: 'Trace sessions.' },
      { name: 'sys.dm_trace_events', description: 'Trace events.' },
      { name: 'sys.dm_trace_filters', description: 'Trace filters.' },
      { name: 'sys.dm_trace_categories', description: 'Trace categories.' },
      { name: 'sys.dm_trace_file', description: 'Trace file information.' },
    ]
  },
  {
    category: 'Resource Governor',
    dmvs: [
      { name: 'sys.dm_resource_governor_configuration', description: 'Resource Governor configuration.' },
      { name: 'sys.dm_resource_governor_resource_pools', description: 'Resource pools.' },
      { name: 'sys.dm_resource_governor_workload_groups', description: 'Workload groups.' },
      { name: 'sys.dm_resource_governor_external_resource_pools', description: 'External resource pools.' },
      { name: 'sys.dm_resource_governor_external_resource_pool_affinity', description: 'Affinity for external resource pools.' },
    ]
  },
  {
    category: 'Other',
    dmvs: [
      { name: 'sys.dm_clr_appdomains', description: 'CLR application domains.' },
      { name: 'sys.dm_clr_loaded_assemblies', description: 'Loaded CLR assemblies.' },
      { name: 'sys.dm_cryptographic_provider_algorithms', description: 'Cryptographic provider algorithms.' },
      { name: 'sys.dm_server_audit_status', description: 'Server audit status.' },
      { name: 'sys.dm_server_memory_dumps', description: 'Memory dump information.' },
      { name: 'sys.dm_server_services', description: 'SQL Server services.' },
      { name: 'sys.dm_server_registry', description: 'SQL Server registry information.' },
    ]
  }
];
